/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import FormField from './FormField';
import Label from './Label';
import TextInput from './TextInput';

/**
 * This component is used to add a hidden set of username/password fields to a
 * form with the intention of fooling Safari (Mac) so that it doesn't autofill
 * saved usernames and passwords into forms that are not login forms. I'm not
 * sure if this still works as intended.
 * TODO: We should find a better solution and remove this hack.
 */
class DummyLogin extends Component {
  render() {
    return (
      <View style={styles.root}>
        <FormField
          render={(id) => (
            <View>
              <Label htmlFor={id}>Username</Label>
              <TextInput id={id} name="username" tabIndex={-1} />
            </View>
          )}
        />
        <FormField
          render={(id) => (
            <View>
              <Label htmlFor={id}>Password</Label>
              <TextInput
                id={id}
                name="password"
                tabIndex={-1}
                secureTextEntry={true}
              />
            </View>
          )}
        />
      </View>
    );
  }
}

let styles = StyleSheet.create({
  root: {
    width: 0,
    height: 0,
    overflow: 'hidden',
    position: 'absolute',
  },
});

export default DummyLogin;
